import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Toast } from 'app/shared/toast/toast';
import { Mimetype } from 'app/shared/mimetype';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IdexService } from 'app/idex.service';
import { MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';

declare let $: any;
@Component({
   selector: 'app-dropbox-list',
   templateUrl: './dropbox-list.component.html',
   styleUrls: ['./dropbox-list.component.css']
})
export class DropboxListComponent {

   items: any[] = [];
   public paths: any[] = [];
   folderId = '';
   @Input() selectedItems: any[];
   @Input() search = false;
   @Input() trash = false;
   @Input() role = 'Admin';
   @Input() tin;
   @Input() shared = false;
   @Input() canDrag = false;
   @Output() clickitem = new EventEmitter<any>();
   @Output() showdocument = new EventEmitter<any>();
   @Output() searchpos = new EventEmitter<number>();
   @Output() uploadNewVersion = new EventEmitter<any>();
   @Output() deleteClicked = new EventEmitter<any>();
   @Output() renameClicked = new EventEmitter<any>();
   nativeElement: any;
   @ViewChild('description') descElement: ElementRef;
   isCheck: any;
   extention = '';
   saveText = 'Save';
   post = 'ส่ง';
   shiftPressed = false;
   info: any;
   hasMore: boolean = false;
   loadData: boolean =  false;
   activeItem: any;
   access_token: any;
   canInput = false;
   disabled = false;
   dragItem : any;

   constructor(private router: Router, public service: IdexService, private toast: Toast, private route: ActivatedRoute,
      private elementRef: ElementRef, private translate: TranslateService, public dialog: MatDialog) {
      this.nativeElement = this.elementRef.nativeElement;
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
      this.items = null;
   }

   setItems(items: any[]) {
      this.items = items;
   }

   addItems(items: any[]) {
      if (items && items.length > 0) {
         if (!this.items) {
            this.items = [];
         }
         this.items.push.apply(this.items, items);
      }
   }

   setCanDrag(val) {
      this.canDrag = val;
   }

   onDragStart(item) {
      this.dragItem = item.id;
      item.drag = true;
   }

   onDragOver(event) {
      event.stopPropagation();
      event.preventDefault();
   }

   onDragLeave(event,item) {
      if(this.dragItem !== item.id){
         item.drag = false;
      }
   }

   onDragEnd(){
      this.items.forEach(o => {
         o.drag = false;
      });
      this.dragItem = '';
   }

   openItem(event: Event, item: any) {
      event.stopPropagation();
      this.clickitem.emit(item);
   }

   onItemClickMenu(event: any, item: any) {
      event.preventDefault();
      this.isCheck = false;
      this.items.forEach(o => {
         o.selected = false;
         const indexDel = this.selectedItems.indexOf(o);
         if (indexDel !== -1) {
            this.selectedItems.splice(indexDel, 1);
         }
      });
      item.selected = true;
      if (this.selectedItems.indexOf(item) === -1) {
         this.selectedItems.push(item);
      }
   }

   beginRename(item: any) {
      this.resetRename();// reset old rename not done
      this.canDrag = false;
      this.canInput = true;
      item.editing = true;
      setTimeout(() => {
         const input = $('#edit-' + item.id).focus()[0];
         let i;
         if (item.mimeType !== 'application/octet-stream') {
            i = item.name.lastIndexOf('.');
            if (i === -1) {
               i = item.name.length;
            } else {
               this.extention = item.name.split('.')[item.name.split('.').length - 1];
            }
         } else {
            i = item.name.length;
         }
         const fileName = item.name.slice(0, i);
         item.name = fileName;
         if (input.setSelectionRange) {
            input.setSelectionRange(0, i);
         } else if (input.createTextRange) {
            const range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', i);
            range.moveStart('character', 0);
            range.select();
         } else if (input.selectionStart) {
            input.selectionStart = 0;
            input.selectionEnd = i;
         }
      }, 200);
   }

   endRename(item: any) {
      this.canDrag = true;
      item.editing = false;
      this.extention = '';
   }

   renameKeyDown(event: KeyboardEvent, item: any) {
      if (event.key === 'Enter') {
         $('#edit-' + item.id).trigger('blur');
      } else if (event.key === 'Escape') {
         $('#edit-' + item.id).val(item.name);
         this.endRename(item);
      }
   }

   resetRename(){
      this.items.forEach(item_state => {
         if(item_state.editing){
            //reset Name old rename not finish
            item_state.name += "."+this.extention;
            this.endRename(item_state);
         }
      });
   }

   rename(item: any) {
      const value = $('#edit-' + item.id).val().trim();
      if (value.length === 0 || this.canInput === false) {
         return;
      } else if (item.name === value) {
         if (this.extention !== '' && this.extention !== undefined && (item.mimeType !== 'application/octet-stream')) {
            item.name += '.' + this.extention;
         }
         this.endRename(item);
      } else if (/[<|>\\\/:?*"]/g.test(value) || /(?=\p{Emoji})(?!\p{Number})/u.test(value)) { // add more check emoji
         this.translate.get('dropbox.rename_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else if (value.endsWith('.')){
         this.translate.get('dropbox.rename_error_dot').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }else {
         let update;
         if (this.extention !== '' && this.extention !== undefined && (item.mimeType !== 'application/octet-stream')) {
            update = value;
            this.renameDropFile(item, update);
         } else {
            if ((item.mimeType === 'application/octet-stream') && value.lastIndexOf('.') === value.length - 1) {
               this.translate.get('alert.create_folder_error_dot').subscribe(s => {
                  this.toast.error(s);
               });
            } else {
               update = value;
               this.renameDropFile(item, update);
            }
         }
      }
   }

   renameDropFile(item: any, newName: any) {
      item['newName'] = newName;
      this.renameClicked.emit(item);
   }

   onClickDelete(item: any) {
      this.deleteClicked.emit(item);
   }

   blobToFile(theBlob: Blob, fileName: string, mimeType: string) {
      return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: mimeType });
   }

   download(item: any) {
      const promise =  this.service.dropboxDownload(this.access_token, '',item.pathDisplay, item.name).toPromise()
            .then(res => {
               const newFile = this.blobToFile(res, item.name, item.mimeType);
               let url = window.URL.createObjectURL(res);
               let a = document.createElement('a');
               document.body.appendChild(a);
               a.setAttribute('style', 'display: none');
               a.href = url;
               a.download = item.name;
               a.click();
               window.URL.revokeObjectURL(url);
               a.remove();
            })
            .catch(error => {
               if (error.status === 401) {
                  this.toast.error('Access token has expired or is not yet valid.');
               } else {
                  this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                     this.toast.error(s);
                  });
               }
            });
      }
   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */

   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = true;
               const index = this.selectedItems.indexOf(o);
               if (index === -1) {
                  this.selectedItems.push(o);
               }
            });
         }
      } else if (e.key === 'd' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = false;
               const index = this.selectedItems.indexOf(o);
               if (index !== -1) {
                  this.selectedItems.splice(index, 1);
               }
            });
            if (this.activeItem) {
               this.activeItem = this.info = undefined;
            }
         }
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   getIcon(item: any): string {
      return Mimetype.getIconDropbox(item);
   }

   getMimeTypeDownload(item: any): string {
      switch (item.mimeType) {
         case 'application/vnd.google-apps.spreadsheet':
            return item.exportLinks['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
         case 'application/vnd.google-apps.presentation':
            return item.exportLinks['application/vnd.openxmlformats-officedocument.presentationml.presentation'];
         case 'application/vnd.google-apps.document':
            return item.exportLinks['application/zip'];
      }
      return item.exportLinks['application/zip'];
   }

   isDownload(item: any): boolean {
      const name = item.name.toLowerCase();
      let isAmpFile = name.lastIndexOf('.amp') > -1;
      let isFolder = item.mimeType == 'application/octet-stream';
      return !isFolder || isAmpFile;
   }

}
